/** User-facing copy when no active membership exists for the selected organization. */

export function formatNoMembershipMessage(displayName) {

  const org = displayName ? ` (${displayName})` : '';

  return (

    `Ni aktivnega članstva za izbrano organizacijo.\n` +
    'Obrnite se na skrbnika sindikata.'

  );

}

